import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustSection from './components/TrustSection';
import HowItWorksPreview from './components/HowItWorksPreview';
import ServicesSection from './components/ServicesSection';
import BrokerBenefits from './components/BrokerBenefits';
import WhoThisIsFor from './components/WhoThisIsFor';
import CTASection from './components/CTASection';
import BrokerApplicationForm from './components/BrokerApplicationForm';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <HeroSection />
      <TrustSection />
      <HowItWorksPreview />
      <ServicesSection />
      <BrokerBenefits />
      <WhoThisIsFor />
      <CTASection />
      <BrokerApplicationForm />
      <Footer />
    </div>
  );
};

export default HomePage;